module.exports = __webpack_public_path__ + "img/1440.44293211.jpg";